import * as Yup from 'yup';

// Esquema de validación para la tabla titulare
export const titulareValidationSchema = Yup.object().shape({
    fecha: Yup.date()
            .required('La fecha es obligatoria')
            .typeError('Debe ser una fecha válida'),
});

export const validateTitulareForm = async (formData) => {
    try {
        await titulareValidationSchema.validate(formData, { abortEarly: false });
        return {}; // No hay errores
    } catch (error) {
        const errors = {};
        if (error.inner) {
            error.inner.forEach((err) => {
                errors[err.path] = err.message;
            });
        }
        return errors; // Devuelve los errores de validación
    }
};